/* unplugin-vue-components disabled */import script from "./TodoList.vue?vue&type=script&setup=true&name=TodoList&lang=js"
export * from "./TodoList.vue?vue&type=script&setup=true&name=TodoList&lang=js"

import "./TodoList.vue?vue&type=style&index=0&id=70f15d2f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70f15d2f"]])

export default __exports__